<template>
    <main id="main" class="main-site">
        <div class="container">
            <Breadcrumb :pages="breadcrumbPages" />

            <Loader v-if="loadingCubos" />

            <div class="main-content-area">
                <div class="row">
                    <div class="col-xs-12">
                        <h3 class="box-title first">{{this.hotsites.tipo}}</h3>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xs-6 col-md-3 text-center m20"
                         v-for="(item, index) in this.hotsites.items"
                         :key="index">
                        <a v-if="hotsites.tipo == 'Marcas'"
                           :href="`${$SiteUrl}/loja/marcas/${string_to_slug(item.Nome)}`">
                            <img v-bind:src="item.Logo" v-bind:alt="item.Alt" v-bind:title="item.Title" />
                        </a>
                        <a v-if="hotsites.tipo == 'Campanhas'"
                           :href="(item.Url.startsWith('http')) ? item.Url : `${$SiteUrl}/loja/campanhas/${item.Url}`">
                            <img v-bind:src="item.Imagem" v-bind:alt="item.Alt" v-bind:title="item.Title" />
                        </a>

                    </div>
                </div>

                <div class="col-md-12" style="padding:0" v-if="descricao">

                    <div v-if="descricao" >
                        <button v-on:click="onClickDiv" aria-label="Ver Mais" class="btnExpandTextArea">{{btnExpand}}</button>
                        <div id="textAreaID" :class="isActive && textAreacustomMarcas" contenteditable="false" v-html="descricao">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script>
    import ProductFilters from "./partials/ProductFilters.vue";
    import Loader from "./partials/Loader.vue";
    import axios from "axios";
    import Breadcrumb from "./partials/Breadcrumb.vue";

    export default {
        name: "CrazyHotSite",
        components: {
            ProductFilters,
            Breadcrumb,
            Loader
        },
        metaInfo() {

            const _self = this;
            var strtitle;
            var strdescription;
            if (_self.$route.path.includes("marcas")) {
                strtitle = "Fabricantes parceiros da Aldo"
                strdescription = "Aldo é distribuidora dos principais fabricantes do setor de TI e  energia solar e conta com mais de 12.000 modelos de geradores. Saiba mais!";
            }
            else
            {
                strtitle = "Campanha e promoções inéditas da Aldo"
                strdescription = "As melhores campanhas do setor de energia solar  e TI você encontra aqui, confira agora e aproveite nossas promoções exclusivas!";
            }
            var url = 'https://www.aldo.com.br';
            url = `${url}${_self.$route.path.replace('/loja', '')}`;
            url = '0; url=' + url;
            if (localStorage.getItem('usuarioLogado') === null && localStorage.getItem('waitingLogin') === null) {
                return {
                    meta: [
                        { 'http-equiv': 'refresh', content: url }
                    ]
                }
            }
            else {
                return {
                    title: strtitle,

                    meta: [
                        { name: 'description', content: strdescription },
                        { name: 'twitter:card', content: strdescription },
                        { name: 'twitter:title', content: strtitle },
                        { name: 'twitter:description', content: strdescription },
                        // image must be an absolute path
                        { name: 'twitter:image', content: "https://www.aldo.com.br/assets/images/logo-top-1.png" },
                        // Facebook OpenGraph
                        { property: 'og:title', content: strdescription },
                        { property: 'og:site_name', content: 'Aldo Solar' },
                        { property: 'og:locale', content: 'pt_BR' },
                        { property: 'og:type', content: 'website' },
                        { property: 'og:image', content: "https://www.aldo.com.br/assets/images/logo-top-1.png" },
                        { property: 'og:description', content: strdescription }
                    ],
                    link: [
                        { rel: 'canonical', href: `${_self.$SiteUrl}${_self.$route.path.replace('/loja', '')}` }
                    ]
                }

            }
        },
        data() {
            return {
                hotsites: {
                    tipo: "",
                    texto: "",
                    items: []
                },
                loadingCubos: true,
                leiaMais: false,
                descricao: "",
                isActive: false,
                textAreacustomMarcas: 'textAreacustomMarcas',
                btnExpand: '-'
            };
        },
        computed: {
            breadcrumbPages: function () {
                let pname = this.$route.path.split('/')[2].toUpperCase();
                let plink = this.$SiteUrl + this.$route.path;
                return [
                    { name: `Home`, link: `${this.$siteUrl}/loja` },
                    { name: pname, link: plink },
                ];
            }
        },
        mounted() {
            const self = this;
            try {
                var xhr = new XMLHttpRequest();

                let tipo = this.$route.path.split('/')[2]

                xhr.onload = () => {
                    if (xhr.status == 200) {
                        this.loadingCubos = false
                        this.hotsites.items = JSON.parse(xhr.responseText);
                    }
                };
                if (tipo == "marcas") {
                    xhr.open("GET", this.$apiUrl + "Marketing.svc/ListMarcas");
                    this.hotsites.tipo = 'Marcas';
                    this.getDescricao('Marcas');
                } else {
                    xhr.open("GET", this.$apiUrl + "Marketing.svc/ListCampanhas");
                    this.hotsites.tipo = 'Campanhas';
                    this.getDescricao('Campanhas');
                }

                xhr.send();
            } catch (error) {
                //   var xhr = new XMLHttpRequest();
                //   xhr.onload = () => {
                //     if (xhr.status == 200) {
                //        this.filtro.items = JSON.parse( xhr.responseText);
                //     }
                //   };
                //     xhr.open("GET", this.$apiUrl + "Produto.svc/getfiltrosporsegmento?slug=energia-solar/inversor" );
                //   xhr.send();
            }
        },
        methods: {
            onClickDiv() {
                if (this.isActive) {
                    this.btnExpand = '-';
                    this.isActive = false;
                }
                else {
                    this.isActive = true;
                    this.btnExpand = '+';
                }
            },
            getDescricao: async function (tipo) {
                const self = this;
                if (tipo == 'Marcas') {
                    axios.get(
                        self.$mktUrl + "/aldo40.asmx/getDescricaoParceiros"
                    ).then(response => {
                        let xml = new window.DOMParser().parseFromString(
                            response.data,
                            "text/xml"
                        );
                        let retornoDescricao = xml.getElementsByTagName("anyType")[0].innerHTML;
                        var descricaoJson = JSON.parse(retornoDescricao)
                        if (descricaoJson && descricaoJson.Descricao) {
                            this.descricao = descricaoJson.Descricao
                        }
                    })
                }
                else {
                    axios.get(
                        self.$mktUrl + "/aldo40.asmx/getDescricaoCampanhas"
                    ).then(response => {
                        let xml = new window.DOMParser().parseFromString(
                            response.data,
                            "text/xml"
                        );
                        let retornoDescricao = xml.getElementsByTagName("anyType")[0].innerHTML;
                        var descricaoJson = JSON.parse(retornoDescricao)
                        if (descricaoJson && descricaoJson.Descricao) {
                            this.descricao = descricaoJson.Descricao
                        }
                    })
                }

            },
            string_to_slug: function (value) {
                value = value.replace(/^\s+|\s+$/g, "");
                value = value.toLowerCase();

                var from = "àáãäâèéëêìíïîòóöôùúüûñç·/_,:;";
                var to = "aaaaaeeeeiiiioooouuuunc------";

                for (var i = 0, l = from.length; i < l; i++) {
                    value = value.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
                }

                value = value
                    .replace(/[^a-z0-9 -]/g, "")
                    .replace(/\s+/g, "-")
                    .replace(/-+/g, "-");

                return value;
            }
        }
    };
</script>
